import { useEffect, useState } from 'react'
import { useAppStore } from '@/shared/store'
import { maxHeightToSetOverflowInApp } from '@/shared/constants/sharedConstant'

export const useAppContainerStyle = () => {
    const { isUserLoggedIn } = useAppStore()
    const [overflow, setOverflow] = useState(
        window.innerHeight > maxHeightToSetOverflowInApp ? 'hidden' : 'visible'
    )

    useEffect(() => {
        const handleResize = () => {
            const windowHeight = window.innerHeight
            setOverflow(
                windowHeight > maxHeightToSetOverflowInApp
                    ? 'hidden'
                    : 'visible'
            )
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const appContainerStyle = {
        position: 'relative',
        overflow: isUserLoggedIn ? 'hidden' : overflow,
        backgroundColor: 'custom.background',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        transition: 'background-image 0.2s ease-in-out',
        maxHeight: '100%',
    }

    return appContainerStyle
}
